import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListSlider from './ListSlider';
import NoAccessoriesMessage from './NoAccessoriesMessage';
import AnimationScrollPage from '../../../../components/AnimationScrollPage';
import { fetchAccessoriesDataAsync } from '../store/accessories/thunk';
import { accessoriesListSelector, apiFailedSelector } from '../store/accessories/selector';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, CTA_ACTION_CATEGORY } from '../../../../constants';

const App = () => {
  const { heading,
    allAccessoriesText,
    allAccessoriesLink,
    allAccessoriesLinkTarget,
    buildYourOwnText,
    buildYourOwnLink,
    buildYourOwnTitle,
    isDisplayBuild,
    contactDealerText,
    contactDealerTitle,
    contactDealerLink,
  } = window.HONDA_SHOP_ACCESSORIES;
  const moduleName = 'shop accessories';
  const relLink = allAccessoriesLinkTarget === '_blank' ? 'noopener noreferrer' : '';
  const dispatch = useDispatch();
  const accessoriesList = useSelector(accessoriesListSelector);
  const apiFailed = useSelector(apiFailedSelector);

  const buildYourOwnRef = useRef(null);
  const contactDealerRef = useRef(null);
  const allAccessoriesRef = useRef(null);

  // get Accessories API data
  useEffect(() => {
    dispatch(fetchAccessoriesDataAsync());
  }, [dispatch]);

  // Animation Scroll Page
  useEffect(() => {
    new AnimationScrollPage().init();
  }, []);

  return (
    <div className="container pt-40 pb-24 md:py-31 2xl:pt-48 2xl:pb-38">
      <div className="animation">
        <div className={`xl:flex xl:justify-between xl:items-center anima-bottom delay-2 ${accessoriesList.length || apiFailed ? 'mb-20 md:mb-29' : ''}`}>
          <h2 className="h4 mb-0 pl-1 max-w-800 md:pl-0 md:text-h4 md:font-bold md:text-dark-black 2xl:text-h3 1k6:text-h4">{heading}</h2>
          <div className="hidden xl:block">
            {isDisplayBuild ? (
              <a href={buildYourOwnLink} className="btn btn-ani btn-text btn-text-primary m-0 pl-0 mr-16"
                data-event-trigger={CLICK_EVENT_TRIGGER}
                data-event-type={CLICK_EVENT_ACTION_TYPE}
                data-event-module={moduleName}
                data-event-label={buildYourOwnText}
                data-event-category={CTA_ACTION_CATEGORY}>{buildYourOwnText}
                <span className="icomoon ml-0 text-h6-2xl xl:ml-3 icon-setting-animation" aria-hidden="true" />
                {buildYourOwnTitle && <span className="sr-only">{buildYourOwnTitle}</span>}
              </a>
            ) : (
              <a href={contactDealerLink} className="btn btn-ani btn-text btn-text-primary m-0 pl-0 mr-16"
                data-event-trigger={CLICK_EVENT_TRIGGER}
                data-event-type={CLICK_EVENT_ACTION_TYPE}
                data-event-module={moduleName}
                data-event-label={contactDealerText}
                data-event-category={CTA_ACTION_CATEGORY}>
                <span className="text">{contactDealerText}</span>
                {contactDealerTitle && <span className="sr-only">{contactDealerTitle}</span>}
                <span className="relative overflow-hidden inline-flex">
                  <span className="icomoon icon-arrow-right-animation" aria-hidden="true" />
                  <span className="icomoon icon-arrow-right-animation absolute -left-11" aria-hidden="true" />
                </span>
              </a>
            )}
            <a href={allAccessoriesLink} className="btn btn-primary m-0 py-7p5 px-[31px]" target={allAccessoriesLinkTarget} rel={relLink}
              data-event-trigger={CLICK_EVENT_TRIGGER}
              data-event-type={CLICK_EVENT_ACTION_TYPE}
              data-event-module={moduleName}
              data-event-label={allAccessoriesText}
              data-event-category={CTA_ACTION_CATEGORY}>
              <span className="text w-fit">{allAccessoriesText}</span>
            </a>
          </div>
        </div>
      </div>
      {accessoriesList.length > 0 &&
        <ListSlider />
      }
      {apiFailed &&
        <NoAccessoriesMessage />
      }
      <div className="text-center mt-7 -mb-3 md:mt-16 xl:hidden down_xs:flex down_xs:flex-col justify-center items-center">
        {isDisplayBuild ? (
          <a ref={buildYourOwnRef} href={buildYourOwnLink} className="btn btn-ani btn-text my-3 mr-0 pl-0 pr-16 down_xs:pr-0 border-0"
            data-event-trigger={CLICK_EVENT_TRIGGER}
            data-event-type={CLICK_EVENT_ACTION_TYPE}
            data-event-module={moduleName}
            data-event-label={buildYourOwnText}
            data-event-category={CTA_ACTION_CATEGORY}>{buildYourOwnText}
            <span className="icomoon ml-0 text-h6-2xl xl:ml-3 icon-setting-animation" aria-hidden="true" />
            {buildYourOwnTitle && <span className="sr-only">{buildYourOwnTitle}</span>}
          </a>
        ) : (
          <a ref={contactDealerRef} href={contactDealerLink} className="btn btn-ani btn-text my-3 mr-0 pl-0 pr-16 down_xs:pr-0 border-0"
            data-event-trigger={CLICK_EVENT_TRIGGER}
            data-event-type={CLICK_EVENT_ACTION_TYPE}
            data-event-module={moduleName}
            data-event-label={contactDealerText}
            data-event-category={CTA_ACTION_CATEGORY}>
            <span className="text">{contactDealerText}</span>
            {contactDealerTitle && <span className="sr-only">{contactDealerTitle}</span>}
            <span className="relative overflow-hidden inline-flex">
              <span className="icomoon icon-arrow-right-animation" aria-hidden="true" />
              <span className="icomoon icon-arrow-right-animation absolute -left-11" aria-hidden="true" />
            </span>
          </a>
        )}
        <a ref={allAccessoriesRef} href={allAccessoriesLink} className="btn btn-primary mx-0 my-3 py-7p5 px-[31px]" target={allAccessoriesLinkTarget} rel={relLink}
          data-event-trigger={CLICK_EVENT_TRIGGER}
          data-event-type={CLICK_EVENT_ACTION_TYPE}
          data-event-module={moduleName}
          data-event-label={allAccessoriesText}
          data-event-category={CTA_ACTION_CATEGORY}>
          <span className="text w-fit">{allAccessoriesText}</span>
        </a>
      </div>
    </div>
  );
};

export default App;